import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { BankAccount } from './models/bank-account.model';
import { Bank } from './models/bank.model';

@Injectable()
export class BankAccountService {
  constructor(private requestService: RequestService) {}

  async getBankAccount(storeId?: number, placeId?: number): Promise<BankAccount> {
    const urlRequest: string =
      APP_CONFIG.WEBSERVICE.BANK_ACCOUNT +
      (storeId ? '?storeId=' + storeId : '?placeId=' + placeId);
    return await this.requestService.getData(urlRequest);
  }

  async getBanks(): Promise<Bank[]> {
    const urlRequest: string = APP_CONFIG.WEBSERVICE.BANK_ACCOUNT + '/banks?status=1';
    return (await this.requestService.getData(urlRequest)) || [];
  }

  async saveBankAccount(bankAccount: BankAccount): Promise<any> {
    const data: any = JSON.parse(JSON.stringify(bankAccount.toJson()));
    console.log(data);
    return await this.requestService.postData(APP_CONFIG.WEBSERVICE.BANK_ACCOUNT, data);
  }

  async updateBankAccount(bankAccount: BankAccount): Promise<any> {
    const data: any = JSON.parse(JSON.stringify(bankAccount.toJson()));
    console.log(data);
    return await this.requestService.putData(APP_CONFIG.WEBSERVICE.BANK_ACCOUNT, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/bank-account/bank-account.service.ts